import { HomeView } from './HomeView';
import {
  Login,
  DashboardView,
  ProfileView,
  SampleComponent,
  RegistrarSectionsListView,
  Page404,
  Page401,
  RegistrarManageStudentsView,
  RegistrarViewEnrolledView,
  RegistrarViewPastRecordsView,
  RegistrarAssignAdvisorySectionView,
  RegistrarAssignSubjectLoadView,
  RegistrarViewSubjectLoadView,
  RegistrarEditSubjectLoadView,
  TeacherViewSubjectLoadView,
  TeacherViewSubjectLoadByIdView,
  TeacherManageGradesView,
  TeacherComponentView,
  TeacherSubcomponentView,
  TeacherAddRecordView,
  TeacherSummaryPerQuarterView,
  TeacherEditRecordView,
  TeacherSummaryView,
  RegistrarIndividualDeliberationView,
  RegistrarGroupDeliberationView,
  RegistrarIndividualDeliberationInfoView,
  RegistrarManageGradesView,
  RegistrarComponentView,
  RegistrarSubcomponentView,
  RegistrarEditRecordView,
  RegistrarAddRecordView,
  RegistrarSummaryReportView,
  RegistrarGroupDeliberationInfoView,
  RegistrarViewStudentRecordView,
  RegistrarViewStudentRecordTeacherView,
  RegistrarViewStudentRecordStudentView,
  RegistrarViewStudentRecordSectionView,
  RegistrarViewStudentRecordGradeView,
  RegistrarViewStudentRecordGradeCompView,
  RegistrarViewStudentRecordGradeSubcompView,
  RegistrarViewStudentRecordGradeSummaryReportView,
  StudentViewGrade,
  TeacherAdviseeGrade,
} from './';

export default {
  path: '/',
  name: 'App',
  childRoutes: [
    { path: 'home-view', name: 'Home view', component: HomeView, isIndex: true },
    { path: '/login', name: 'Login', component: Login },
    { path: '/dashboard', name: 'Dashboard view', component: DashboardView },
    { path: '/profile', name: 'Profile view', component: ProfileView },
    { path: '/sampleComponent', name: 'Sample component', component: SampleComponent },
    {
      path: '/sectionslist',
      name: 'Registrar add section view',
      component: RegistrarSectionsListView,
    },
    { path: 'page404', name: 'Page 404', component: Page404 },
    { path: 'page401', name: 'Page 401', component: Page401 },
    {
      path: '/managestudents',
      name: 'Registrar enroll students view',
      component: RegistrarManageStudentsView,
    },
    {
      path: 'managestudents/viewenrolled/:id',
      name: 'Registrar view enrolled view',
      component: RegistrarViewEnrolledView,
    },
    {
      path: 'managestudents/viewpastrecords/:id',
      name: 'Registrar view past records view',
      component: RegistrarViewPastRecordsView,
    },
    {
      path: 'assignadvisorysection',
      name: 'Registrar assign advisory section view',
      component: RegistrarAssignAdvisorySectionView,
    },
    {
      path: 'assignsubjectload',
      name: 'Registrar assign subject load view',
      component: RegistrarAssignSubjectLoadView,
    },
    {
      path: 'assignsubjectload/viewload/:id',
      name: 'Registrar view subject load view',
      component: RegistrarViewSubjectLoadView,
    },
    {
      path: 'assignsubjectload/viewload/:id/edit/:id2',
      name: 'Registrar edit subject load view',
      component: RegistrarEditSubjectLoadView,
    },
    {
      path: '/viewsubjectload',
      name: 'Teacher view subject load view',
      component: TeacherViewSubjectLoadView,
    },
    {
      path: '/viewsubjectload/:id/:q',
      name: 'Teacher view subject load by id view',
      component: TeacherViewSubjectLoadByIdView,
    },
    {
      path: '/managegrades/:id/:q',
      name: 'Teacher manage grades view',
      component: TeacherManageGradesView,
    },
    {
      path: '/managegrades/:id/:q/:comp',
      name: 'Teacher component view',
      component: TeacherComponentView,
    },
    {
      path: '/managegrades/:id/:q/:comp/subcomp/:subcomp',
      name: 'Teacher subcomponent view',
      component: TeacherSubcomponentView,
    },
    {
      path: '/managegrades/:id/:q/:comp/subcomp/:subcomp/addrecord',
      name: 'Teacher add record view',
      component: TeacherAddRecordView,
    },
    {
      path: '/summaryreport/:id/:q',
      name: 'Teacher summary per quarter view',
      component: TeacherSummaryPerQuarterView,
    },
    {
      path: '/managegrades/:id/:q/:comp/subcomp/:subcomp/editrecord/:rec',
      name: 'Teacher edit record view',
      component: TeacherEditRecordView,
    },
    { path: '/summaryreportall/:id', name: 'Teacher summary view', component: TeacherSummaryView },
    {
      path: 'individualdeliberation',
      name: 'Registrar individual deliberation view',
      component: RegistrarIndividualDeliberationView,
    },
    {
      path: 'groupdeliberation',
      name: 'Registrar group deliberation view',
      component: RegistrarGroupDeliberationView,
    },
    {
      path: 'individualdeliberation/:id',
      name: 'Registrar individual deliberation info view',
      component: RegistrarIndividualDeliberationInfoView,
    },
    {
      path: 'individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q',
      name: 'Registrar manage grades view',
      component: RegistrarManageGradesView,
    },
    {
      path: 'individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q/comp/:comp',
      name: 'Registrar component view',
      component: RegistrarComponentView,
    },
    {
      path:
        'individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q/comp/:comp/subcomp/:subcomp',
      name: 'Registrar subcomponent view',
      component: RegistrarSubcomponentView,
    },
    {
      path:
        '/individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q/comp/:comp/subcomp/:subcomp/editrecord/:rec',
      name: 'Registrar edit record view',
      component: RegistrarEditRecordView,
    },
    { path: '/individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q/comp/:comp/subcomp/:subcomp/addrecord', name: 'Registrar add record view', component: RegistrarAddRecordView },
    { path: 'individualdeliberation/:id/managegrade/:classRecordID/quarter/:Q/summaryreport', name: 'Registrar summary report view', component: RegistrarSummaryReportView },
    { path: 'groupdeliberation/:id', name: 'Registrar group deliberation info view', component: RegistrarGroupDeliberationInfoView },
    { path: 'viewstudentrecord', name: 'Registrar view student record view', component: RegistrarViewStudentRecordView },
    { path: 'viewstudentrecord/teacher/:id/sy/:sy/q/:q', name: 'Registrar view student record teacher view', component: RegistrarViewStudentRecordTeacherView },
    { path: 'viewstudentrecord/student/:id/sy/:sy/q/:q', name: 'Registrar view student record student view', component: RegistrarViewStudentRecordStudentView },
    { path: 'viewstudentrecord/section/:id/sy/:sy/q/:q', name: 'Registrar view student record section view', component: RegistrarViewStudentRecordSectionView },
    { path: 'viewstudentrecord/classrecord/:classRecordID/q/:q', name: 'Registrar view student record grade view', component: RegistrarViewStudentRecordGradeView },
    { path: '/viewstudentrecord/classrecord/:classRecordID/q/:q/comp/:comp', name: 'Registrar view student record grade comp view', component: RegistrarViewStudentRecordGradeCompView },
    { path: '/viewstudentrecord/classrecord/:classRecordID/q/:q/comp/:comp/subcomp/:subcomp', name: 'Registrar view student record grade subcomp view', component: RegistrarViewStudentRecordGradeSubcompView },
    { path: '/viewstudentrecord/classrecord/:classRecordID/q/:q/summaryreport', name: 'Registrar view student record grade summary report view', component: RegistrarViewStudentRecordGradeSummaryReportView },
    { path: 'viewstudentgrade', name: 'Student view grade', component: StudentViewGrade },
    { path: 'viewadviseegrades', name: 'Teacher advisee grade', component: TeacherAdviseeGrade },
  ],
};



// WEBPACK FOOTER //
// ./src/features/app/route.js